import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type {
  ContactsParams,
  ShipperContacts,
} from 'src/apis/organisation-service/types';
import type { AssignedShipperDetailsRequest } from 'src/apis/organisation-service/use-assigned-shipper-details';
import { useAxios } from 'src/hooks/use-axios';

type Options = {
  assignedShipperDetails: AssignedShipperDetailsRequest;
  params?: ContactsParams;
};

export function useOptionalShipperContacts({
  assignedShipperDetails,
  params,
}: Options) {
  const request = useAxios(
    (
      axios,
      baseConfig,
      { url, params }: { url: string; params?: ContactsParams }
    ) =>
      axios.request<ShipperContacts>({
        ...baseConfig,
        url: urlTemplate.parse(url).expand({}),
        params,
      }),
    {
      neededOnPageLoad: true,
    }
  );

  useEffect(() => {
    if (
      !assignedShipperDetails.response?.data._links.getAssignedShipperContacts
    )
      return;
    const contactsUrl = urlTemplate
      .parse(
        assignedShipperDetails.response.data._links.getAssignedShipperContacts
          .href
      )
      .expand({});

    request.execute({ url: contactsUrl, params });
    // oxlint-disable-next-line exhaustive-deps
  }, [assignedShipperDetails.response, params]);

  if (!assignedShipperDetails.response?.data._links.getAssignedShipperContacts)
    return;

  return request;
}

export type OptionalShipperContactsRequest = ReturnType<
  typeof useOptionalShipperContacts
>;
